import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import React from "react";
import { Tab, Nav } from "react-bootstrap";
import AssetStatusCards from "./assetsWidgets/AssetStatusCards";
import AssetTypesGrid from "./assetsWidgets/AssetTypesGrid";
import AssetListTab from "./assetsTabs/AssetListTab";
import SmartAssetProfilingTab from "./assetsTabs/SmartAssetProfilingTab";
import AssetAlertsTab from "./assetsTabs/AssetAlertsTab";
import MisconfigurationsTab from "./assetsTabs/MisconfigurationsTab";
import VulnerabilitiesTab from "./assetsTabs/VulnerabilitiesTab";
import UpdateHistoryTab from "./assetsTabs/UpdateHistoryTab";

export default function AssetsPage() {
	const [activeTab, setActiveTab] = useState("overview");

	useEffect(() => {
		// getAssetsAnalytics();
	}, []);

	const tabItems = [
		{ id: "overview", label: "Asset Overview", count: null },
		{ id: "list", label: "Asset List", count: 8 },
		{ id: "profiling", label: "Smart Asset Profiling", count: null },
		{ id: "alerts", label: "Asset Alerts", count: 5 },
		{ id: "misconfigs", label: "Misconfigurations", count: 0 },
		{ id: "vulns", label: "Vulnerabilities", count: 5 },
		{ id: "history", label: "Update History", count: 6 },
	];

	return (
		<>
			<Helmet>
				<title>Assets | Sec1 Software Pvt. Ltd.</title>
			</Helmet>

			<div id="kt_app_toolbar" className="app-toolbar pt-12 rounded-0">
				<div
					id="kt_app_toolbar_container"
					className="app-container container-fluid d-flex align-items-stretch"
				>
					<div className="app-toolbar-wrapper d-flex flex-stack flex-wrap gap-4 w-100">
						<div className="page-title d-flex flex-column gap-1 me-3 mb-2">
							<h1 className="page-heading d-flex flex-column justify-content-center text-dark fw-bolder fs-1 lh-0">
								Assets
							</h1>
						</div>
					</div>
				</div>
			</div>

			<div id="kt_app_content" className="app-content flex-column-fluid">
				<div
					id="kt_app_content_container"
					className="app-container container-fluid"
				>
					<Tab.Container
						activeKey={activeTab}
						onSelect={(k) => setActiveTab(k)}
						className="mb-6"
					>
						<Nav
							variant="tabs"
							className="nav-line-tabs nav-line-tabs-2x border-transparent flex-nowrap"
							style={{
								borderBottomColor: "#3a3a52 !important",
								overflowX: "auto",
								paddingBottom: "4px",
								backgroundColor: "transparent",
								justifyContent: "flex-start",
							}}
						>
							{tabItems.map((tab) => (
								<Nav.Item key={tab.id}>
									<Nav.Link
										eventKey={tab.id}
										style={{
											color:
												activeTab === tab.id
													? "#ffffff"
													: "#6b7280",
											borderBottomColor:
												activeTab === tab.id
													? "#3b82f6"
													: "transparent",
											borderBottom:
												activeTab === tab.id
													? "3px solid #3b82f6"
													: "none",
											transition: "all 0.3s ease",
											whiteSpace: "nowrap",
											padding: "12px 16px",
											fontSize: "14px",
										}}
									>
										{tab.label}
										{tab.count !== null && (
											<span
												style={{
													marginLeft: 8,
													padding: "2px 8px",
													backgroundColor:
														activeTab === tab.id
															? "#3b82f6"
															: "#4a5568",
													borderRadius: 4,
													fontSize: 12,
													fontWeight: 600,
													color: "#ffffff",
												}}
											>
												{tab.count}
											</span>
										)}
									</Nav.Link>
								</Nav.Item>
							))}
						</Nav>

						<Tab.Content>
							{/* Asset Overview Tab */}
							<Tab.Pane eventKey="overview">
								<AssetStatusCards />
								<AssetTypesGrid />
							</Tab.Pane>

							{/* Asset List Tab */}
							<Tab.Pane eventKey="list">
								<AssetListTab />
							</Tab.Pane>

							{/* Smart Asset Profiling Tab */}
							<Tab.Pane eventKey="profiling">
								<SmartAssetProfilingTab />
							</Tab.Pane>

							{/* Asset Alerts Tab */}
							<Tab.Pane eventKey="alerts">
								<AssetAlertsTab />
							</Tab.Pane>

							{/* Misconfigurations Tab */}
							<Tab.Pane eventKey="misconfigs">
								<MisconfigurationsTab />
							</Tab.Pane>

							{/* Vulnerabilities Tab */}
							<Tab.Pane eventKey="vulns">
								<VulnerabilitiesTab />
							</Tab.Pane>

							{/* Update History Tab */}
							<Tab.Pane eventKey="history">
								<UpdateHistoryTab />
							</Tab.Pane>
						</Tab.Content>
					</Tab.Container>
				</div>
			</div>
		</>
	);
}
